"use strict";

var get = require('lodash.get');
var makeGetAuthResult = function makeGetAuthResult(_ref) {
  var client = _ref.client;
  return function () {
    return client.parseHashAsync({
      hash: window.location.hash
    }).then(function (authResultFromParseHash) {
      var accessToken = get(authResultFromParseHash, 'accessToken');
      if (accessToken) {
        return authResultFromParseHash;
      }

      // Fallback to checkSession when parseHash fails
      return client.checkSessionAsync({}).catch(function () {});
    });
  };
};

// Used to persist token after login
var makeLoginCallback = function makeLoginCallback(_ref2) {
  var client = _ref2.client,
    setTokenInCookie = _ref2.setTokenInCookie;
  var getAuthResult = makeGetAuthResult({
    client: client
  });
  return function () {
    return getAuthResult().then(function (authResult) {
      var accessToken = get(authResult, 'accessToken');
      var state = get(authResult, 'state');
      if (!accessToken) {
        return Promise.reject(new Error('Failed to get accessToken from login callback'));
      }
      setTokenInCookie(accessToken);
      return {
        accessToken: accessToken,
        state: state
      };
    });
  };
};
module.exports = {
  makeLoginCallback: makeLoginCallback
};